import { useEffect, useState } from 'react';
import type { WorldDraft } from '../../../domain/types.js';
import { resolveAppearanceCatalog } from './appearanceCatalogCache.js';
import {
  appearanceCatalogForDraft,
  appearanceCatalogKeyForDraft,
  type AppearanceCatalog,
  type AppearanceCatalogSource,
} from './appearanceOptions.js';

export interface AppearanceCatalogState {
  catalog: AppearanceCatalog;
  source: AppearanceCatalogSource;
  loading: boolean;
  key: string;
}

export function useAppearanceCatalog(
  draft: WorldDraft,
  species: string,
  draftCharacterId: string,
  sex: 'M' | 'F' = 'M',
): AppearanceCatalogState {
  const [state, setState] = useState<AppearanceCatalogState>(() => ({
    catalog: appearanceCatalogForDraft(draft, species, sex),
    source: 'seeded',
    loading: true,
    key: appearanceCatalogKeyForDraft(draft, species, sex),
  }));

  useEffect(() => {
    let cancelled = false;
    const seeded = appearanceCatalogForDraft(draft, species, sex);
    const key = appearanceCatalogKeyForDraft(draft, species, sex);
    setState({ catalog: seeded, source: 'seeded', loading: true, key });

    void resolveAppearanceCatalog({ draft, species, draftCharacterId, sex }).then((result) => {
      if (cancelled) return;
      setState({
        catalog: result.catalog,
        source: result.source,
        loading: false,
        key: result.key,
      });
    });

    return () => {
      cancelled = true;
    };
  }, [draft, species, draftCharacterId, sex]);

  return state;
}
